import { render, staticRenderFns } from "./no-company.vue?vue&type=template&id=1411a87a&"
import script from "./no-company.vue?vue&type=script&lang=js&"
export * from "./no-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports